import MyLibraryResponse from "../models/myLibrary/MyLibraryResponse";
import NamedCourseList from "../models/myLibrary/NamedCourseList";
import Course from "../models/myLibrary/Course";
import SongCategory from "../models/myLibrary/SongCategory";
import IFeaturedBootcampLesson from "../models/myLibrary/IFeaturedBootcampLesson";

export function createMyLibraryResponseFromJson(json: object = {}): MyLibraryResponse{
  //@ts-ignore
  const {courseSections: courseSectionsJson = [], songCategories: songCategoriesJson = [], featuredBootcampLesson: featuredBootcampJson} = json;
  const courseSections = courseSectionsJson.map(createCourseSectionFromJson);
  const songCategories = songCategoriesJson.map(createSongCategoryFromJson);
  let featuredBootcampLesson = featuredBootcampJson as IFeaturedBootcampLesson;

  return new MyLibraryResponse({courseSections, songCategories, featuredBootcampLesson});
}

function createCourseSectionFromJson(json: object = {}): NamedCourseList{
  //@ts-ignore
  const {name, courses: coursesJson = []} = json;
  const courses = coursesJson.map(createCourseFromJson);
  return new NamedCourseList({name, courses});
}

function createCourseFromJson(json: object = {}): Course {
  //@ts-ignore
  const {id, name, difficulty, difficultyCategories, theme, imgUrl, description, lessonCount} = json;
  return new Course({id, name, difficulty, difficultyCategories, theme, imgUrl, description, lessonCount});
}

function createSongCategoryFromJson(json: object = {}): SongCategory{
  //@ts-ignore
  const {name, categoryType} = json;
  return new SongCategory({name, categoryType});
}